module.exports = __webpack_public_path__ + "static/fonts/Outfit-Regular.9f444021.ttf";